import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { axiosInstance } from "../../Config";
import "@fancyapps/fancybox/dist/jquery.fancybox.css";
import "@fancyapps/fancybox";

const TransactionList = () => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [dateFilter, setDateFilter] = useState("all");
  const limit = 10;

  const dateFilters = [
    { value: "all", label: "All Data" },
    { value: "7", label: "Last 7 Days" },
    { value: "30", label: "This Month" },
    { value: "180", label: "Last 6 Months" },
    { value: "365", label: "Last Year" },
  ];

  useEffect(() => {
    const t = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm.trim());
    }, 500);

    return () => clearTimeout(t);
  }, [searchTerm]);

  const fetchMatches = async (page, search = "", filter = "all") => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `/transactionList?page=${page}&limit=${limit}&search=${encodeURIComponent(
          search,
        )}&dateFilter=${filter}`,
      );
      if (response.data.success) {
        setUsers(response?.data?.body?.data || []);
        setTotalPages(response?.data?.body?.totalPages);
      } else {
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMatches(currentPage, searchTerm, dateFilter);
  }, [currentPage, debouncedSearchTerm, dateFilter]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleDateFilter = (value) => {
    setDateFilter(value);
    setCurrentPage(1);
  };

  const getCurrentFilterLabel = () => {
    const filter = dateFilters.find((f) => f.value === dateFilter);
    return filter ? filter.label : "All Data";
  };

  return (
    <>
      <div id="layout-wrapper">
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <div className="title-box mb-3 pb-1">
                <h4 className="mb-0 page-title">Transaction List</h4>
                <nav aria-label="breadcrumb" className="mt-1">
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard" className="new">
                        <i className="ri-home-4-fill me-1 new" /> Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/transactionlist" className="new">
                        Transactions
                      </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Transactions Listing
                    </li>
                  </ol>
                </nav>
              </div>

              <div className="card">
                <div className="card-body cusbar">
                  {loading ? (
                    <div
                      className="loader"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "59%",
                        transform: "translate(-50%, -50%)",
                      }}
                    >
                      <div
                        className="spinner-border"
                        role="status"
                        style={{
                          width: "50px",
                          height: "50px",
                          color: "#963F02",
                        }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="card-head mb-3 d-flex justify-content-between align-items-center">
                        <div className="d-flex">
                          <div className="tbl-search position-relative me-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search.."
                              value={searchTerm}
                              onChange={handleSearchChange}
                            />
                            <i className="ri-search-line" />
                          </div>

                          <div className="dropdown tbl-drop">
                            <button
                              className="btn btn-light dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              {getCurrentFilterLabel()}
                            </button>
                            <ul className="dropdown-menu">
                              {dateFilters.map((filter) => (
                                <li key={filter.value}>
                                  <button
                                    className="dropdown-item"
                                    type="button"
                                    onClick={() =>
                                      handleDateFilter(filter.value)
                                    }
                                  >
                                    {filter.label}
                                  </button>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="table-responsive table-card border-top">
                        <div data-simplebar="" className="cus-scroll scmob">
                          <table className="table table-centered cus-nowrap align-middle hltr mb-0">
                            <thead>
                              <tr>
                                <th>Sr no.</th>
                                <th>Plan Id</th>
                                <th>Paid by(name)</th>
                                <th>Paid by(email)</th>
                                <th>Amount (in $)</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {users.length > 0
                                ? users.map((user, index) => (
                                    <tr key={user?.id}>
                                      <td>
                                        {(currentPage - 1) * limit + index + 1}
                                      </td>
                                      <td>{user?.plan_id || ""}</td>

                                      <td>{user?.paid_by?.name || ""}</td>
                                      <td>{user?.paid_by?.email || ""}</td>
                                      <td>{user?.amount || ""}</td>
                                      <td>
                                        {user?.payment_status == 0
                                          ? "Pending"
                                          : user?.payment_status == 1
                                            ? "Success"
                                            : user?.payment_status == 2
                                              ? "Failed"
                                              : ""}
                                      </td>
                                    </tr>
                                  ))
                                : !loading && (
                                    <tr>
                                      <td
                                        colSpan="7"
                                        style={{
                                          textAlign: "center",
                                          padding: "20px",
                                        }}
                                      >
                                        No transaction found
                                      </td>
                                    </tr>
                                  )}
                            </tbody>
                          </table>
                          {totalPages && totalPages > 1 ? (
                            <div className="d-flex justify-content-center align-items-center mt-3">
                              <Stack
                                spacing={2}
                                className="d-flex justify-content-center mt-3"
                              >
                                <Pagination
                                  count={totalPages}
                                  page={currentPage}
                                  onChange={handlePageChange}
                                  color="error"
                                />
                              </Stack>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionList;
